// T-75b: the "Mute all sessions" row covering a peer: only a Sessions row (CLI, no cybo) of the
// message's workspace, from its live roster or, in the background, the one cached on this device.
import { workspaceState, authState } from "../core/state.svelte.js";
import { loadRosterCache } from "../core/agent-roster-cache.js";
import { sessionAllScopeId } from "../session-notification-scope.js";

interface RosterRow {
  agentId: string;
  cyboId?: string | null;
}

const READ_TTL_MS = 1_000; // the badge total asks once per count key
const background = new Map<string, { at: number; owner: string; rows: readonly RosterRow[] }>();

function rosterOf(wsId: string, now = Date.now()): readonly RosterRow[] {
  if (wsId === workspaceState.current?.id) return workspaceState.agents as RosterRow[];
  const owner = authState.user?.email ?? "";
  const hit = background.get(wsId);
  if (hit && hit.owner === owner && now - hit.at < READ_TTL_MS) return hit.rows;
  const store = typeof localStorage === "undefined" ? null : localStorage; // null: no storage (SSR)
  const rows = loadRosterCache(store, wsId, owner);
  background.set(wsId, { at: now, owner, rows });
  return rows;
}

// An agent with no cybo, once that workspace's cybo list has answered (undefined: still loading).
export function sessionAllScopeForMessage(
  m: { fromType?: string; fromId: string; cyboId?: string },
  wsId: string | undefined,
  cyboIds: readonly string[] | undefined,
): string | undefined {
  if (!wsId || !cyboIds || m.fromType !== "agent" || m.cyboId || cyboIds.includes(m.fromId)) return undefined; // prettier-ignore
  const cyboBound = rosterOf(wsId).some((a) => a.agentId === m.fromId && Boolean(a.cyboId));
  return cyboBound ? undefined : sessionAllScopeId(wsId);
}

export function sessionAllScopeFor(peerId: string, wsId: string | undefined): string | undefined {
  if (!wsId) return undefined;
  const isSessionRow = rosterOf(wsId).some((a) => a.agentId === peerId && a.cyboId == null);
  return isSessionRow ? sessionAllScopeId(wsId) : undefined;
}
